export default __webpack_public_path__ + "static/media/iwebdesignresponsive.1c582f0b.gif";